export function cleanSessionFromURL(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has('session_token')) return;
  url.searchParams.delete('session_token');
  window.history.replaceState(null, '', url);
}
